"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const field_factory_1 = __importDefault(require("./field-factory"));
const getFieldConfigs = ({ fields, entityData, isReadOnly }) => {
    const fieldsWithShims = (0, utils_1.applyShims)(fields);
    const fieldsWithDefaultConfigs = (0, utils_1.attachDefaultConfigs)(fieldsWithShims);
    const fieldsWithOrderProp = (0, utils_1.setImplicitOrder)(Array.isArray(fieldsWithDefaultConfigs)
        ? fieldsWithDefaultConfigs
        : fieldsWithShims);
    const transformedFields = (0, utils_1.transformGroupedFields)(fieldsWithOrderProp);
    const fieldConfigs = (0, field_factory_1.default)(transformedFields, entityData, isReadOnly);
    const orderedFields = (0, utils_1.orderFields)(fieldConfigs);
    return orderedFields;
};
exports.default = getFieldConfigs;
//# sourceMappingURL=get-field-configs.js.map